import axios from 'axios';
import router from './router';


const api = axios.create();
api.interceptors.request.use(
    config => {
        if (localStorage.getItem('access_token')) {

            config.headers = {
                'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
            }
        } else {
            config.headers = {
                'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
            }
        }
        return config
    }, error => {
        if ((error.response.status === 401) && (localStorage.getItem('access_token'))) {

            return axios.post('api/auth/refresh', {}, {
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
                }
            }).then(response => {
                localStorage.setItem('access_token', response.data.access_token)
                error.config.headers.authorization = `Bearer ${response.data.access_token}`
                return api.request(error.config)
            }).catch(function() {
                router.push({ name: 'login' })
                localStorage.removeItem('access_token')
            });
        } else {
            if (error.response.status === 401) {
                router.push({ name: 'login' })
                localStorage.removeItem('access_token')
            }
        }
    })
api.interceptors.response.use(
    config => {
        if (localStorage.getItem('access_token')) {

            config.headers = {
                'authorization': `Bearer ${localStorage.getItem('access_token')}`
            }
        } else {
            config.headers = {
                'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
            }
        }
        return config
    }, error => {

        if ((error.response.status === 401) && (localStorage.getItem('access_token'))) {

            return axios.post('api/auth/refresh', {}, {
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
                }
            }).then(response => {
                localStorage.setItem('access_token', response.data.access_token)
                error.config.headers.authorization = `Bearer ${response.data.access_token}`
                return api.request(error.config)
            }).catch(function() {
                router.push({ name: 'login' })
                localStorage.removeItem('access_token')
            });
        } else {
            if (error.response.status === 401) {
                router.push({ name: 'login' })
                localStorage.removeItem('access_token')
            }
        }

    })
export default api